<template>
  <img
    alt=""
    ref="picture"
    :src="getUrl(media)"
    @load="successLoad"
    @error="error"
  />
</template>

<script>
import AdMediaController from '@/components/playlist/ad-media-playlist/ad-media-controller'
import AdItem from '@/app/service/api/model/ad/ad-item-type/ad-item'

export default {
  name: 'AdImage',
  mixins: [AdMediaController],
  props: {
    media: {
      type: AdItem,
      required: true
    }
  },
  data () {
    return {
      pictureTimeout: null
    }
  },
  watch: {
    media () {
      this.playPicture()
    }
  },
  computed: {
    pictureDuration () {
      return this.media.getDuration() * 1000
    }
  },
  methods: {
    playPicture () {
      this.pictureTimeout = setTimeout(() => {
        this.ended()
        clearTimeout(this.pictureTimeout)
      }, this.pictureDuration)
    }
  },
  mounted () {
    this.playPicture()
  },
  beforeDestroy () {
    clearTimeout(this.pictureTimeout)
  }
}
</script>
